import { render, staticRenderFns } from "./MyApproval.vue?vue&type=template&id=a1e62d3a&scoped=true"
import script from "./MyApproval.vue?vue&type=script&lang=js"
export * from "./MyApproval.vue?vue&type=script&lang=js"
import style0 from "./MyApproval.vue?vue&type=style&index=0&id=a1e62d3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e62d3a",
  null
  
)

export default component.exports